import { Box, Typography, useTheme } from '@mui/material'
import BreadCrum from '../../lib/BreadCrum';
import { useHistory } from 'react-router';
import SelfDeclaration from './SelfDeclaration';
import Details from './Details';

export default function MyProfile() {
    const theme = useTheme();
    const history = useHistory();
    const initialRouter = history.location.pathname?.split('/').filter((item) => item !== '')

    const rmRouterPath =
        [
            {
                name: 'Dashboard',
                path: '/dashboard',
                warning: false
            },
            {
                name: 'My Profile',
                path: `/${initialRouter[0]}`,
            },
        ]
    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <BreadCrum array={rmRouterPath} />
            </Box>
            <Box mb="25px" mt={2}>
                <Typography variant='h1' color="text.primary">
                    My Profile
                </Typography>
            </Box>
            <Box
                sx={{
                    mt: 3,
                    p: 3,
                    border: `1px solid ${theme.palette.text.primary}`,
                    borderRadius: '15px',
                    display: 'flex',
                    flexDirection: 'column',
                }}>
                <Box>
                    <Details />
                </Box>
                <Box sx={{ mt: 2 }}>
                    <SelfDeclaration />
                </Box>
            </Box>
        </>
    )
}
